export default __webpack_public_path__ + "static/media/cameraLens.bd5f1ece.png";